import { useCallback, useEffect, useMemo } from "react"

import { useCampaigns } from "@l2r-front/l2r-shared-campaign"
import { Pagination, useIsMobileDevice } from "@l2r-front/l2r-ui"
import { useApplicationStateContext, useUrlParams } from "@l2r-front/l2r-utils"

import { CAMPAIGNS_COUNT_PER_PAGE, NETWORK_CAMPAIGNS_PAGE } from "../../constants/urlParams"

import * as Styled from "./CampaignSidebarContent.styled"

interface CampaignSidebarContentProps {
    className?: string
}

export function CampaignSidebarContent(props: CampaignSidebarContentProps) {

    const {
        className,
    } = props

    const isMobile = useIsMobileDevice()
    const { currentBottomSheetHeight } = useApplicationStateContext()

    const { getParam, setParam } = useUrlParams()

    const page = useMemo(() => {
        return parseInt(getParam(NETWORK_CAMPAIGNS_PAGE)) || 1
    }, [getParam])

    const { data, isLoading, isError } = useCampaigns(
        {
            offset: (page - 1) * CAMPAIGNS_COUNT_PER_PAGE,
            limit: CAMPAIGNS_COUNT_PER_PAGE,
        })

    const pageCount = useMemo(() => {
        if (!data || !data.count) {
            return 0
        }
        return Math.ceil(data.count / CAMPAIGNS_COUNT_PER_PAGE)
    }, [data])

    const handleChangePage = useCallback(
        (_, newPage) => {
            setParam(NETWORK_CAMPAIGNS_PAGE, newPage)
        }, [setParam],
    )

    useEffect(() => {
        if (!isLoading && !isError && page > pageCount && pageCount > 0) {
            setParam(NETWORK_CAMPAIGNS_PAGE, pageCount)
        }
    }, [isError, isLoading, page, pageCount, setParam])

    return (
        <Styled.Container className={className} isMobile={isMobile} id="campaignSidebarContent-container">
            <Styled.List campaigns={data?.results} hoverHandling isLoading={isLoading} isError={isError} />
            {pageCount > 1 && <Styled.PaginationContainer position={isMobile && currentBottomSheetHeight < 80 ? "static" : "sticky"} isMobile={isMobile}>
                <Pagination
                    page={page}
                    count={pageCount}
                    onChange={handleChangePage} />
            </Styled.PaginationContainer>}
        </Styled.Container>
    )
}
